/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Skeleton, Typography2, breakpoints } from '@coursera/cds-core';

const styles = {
  contentContainer: () => css`
    margin: var(--cds-spacing-600) 0;
  `,
  videoOverlayPlaceholder: () => css`
    width: 750px;
    height: 421px !important;
    margin-bottom: var(--cds-spacing-300);

    ${breakpoints.down('xs')} {
      width: 358px;
      height: 201px !important;
    }
  `,
  imageSkeleton: () => css`
    display: inline-block;
    width: 80px;
    height: 80px !important;
    margin-right: var(--cds-spacing-100);
    ${breakpoints.down('xs')} {
      width: 70px;
      height: 70px !important;
    }
  `,
  descriptionSkeleton: () => css`
    margin-bottom: var(--cds-spacing-300);
    width: 600px;
    ${breakpoints.down('xs')} {
      width: 200px;
    }
  `,
  ctaSkeleton: () => css`
    width: 162px;
    height: 48px !important;
    ${breakpoints.down('xs')} {
      width: 80%;
      margin: var(--cds-spacing-100) auto;
    }
  `,
  courseDetailsSkeleton: () => css`
    width: 400px;
    ${breakpoints.down('xs')} {
      width: 250px;
    }
  `,
};

const VLPVideoPlayerPlaceholder = () => {
  return (
    <div css={styles.contentContainer} data-testid="vlp_video_player_placeholder">
      <Skeleton variant="rect" css={styles.videoOverlayPlaceholder} />
      <Typography2 component="p" variant="bodySecondary" css={styles.descriptionSkeleton}>
        <Skeleton />
      </Typography2>
      <Grid container>
        <Grid item css={styles.imageSkeleton} variant="rect" component={Skeleton} />
        <Grid item xs={8} container direction="column">
          <Skeleton css={styles.courseDetailsSkeleton} height={30} />
          <Skeleton width={100} height={30} />
          <Skeleton css={styles.courseDetailsSkeleton} height={30} />
          <Skeleton css={styles.courseDetailsSkeleton} height={30} />
        </Grid>
        <Grid item xs={12} sm css={styles.ctaSkeleton} variant="rect" component={Skeleton} />
      </Grid>
    </div>
  );
};

export default VLPVideoPlayerPlaceholder;
